import { render, staticRenderFns } from "./LandingSteps.vue?vue&type=template&id=641c45f2&scoped=true"
import script from "./LandingSteps.vue?vue&type=script&lang=ts"
export * from "./LandingSteps.vue?vue&type=script&lang=ts"
import style0 from "./LandingSteps.vue?vue&type=style&index=0&id=641c45f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c45f2",
  null
  
)

export default component.exports